// import React, { useState } from "react";
// import "./ContactUs.css";

// const ContactUs = () => {
//   // Step 1: Form state
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     subject: "",
//     message: "",
//   });

//   // Step 2: Handle input changes
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   // Step 3: Handle form submit
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const res = await fetch("http://localhost:5000/api/sendMail", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(formData),
//       });

//       const data = await res.json();

//       if (data.success) {
//         alert("✅ Message sent successfully!");
//         setFormData({ name: "", email: "", subject: "", message: "" });
//       } else {
//         alert("❌ Failed to send message.");
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       alert("⚠️ Something went wrong. Try again later.");
//     }
//   };

//   return (
//     <div>
//       <section className="contact-section">
//         <div className="container contact-container">
//           {/* Contact Info Cards */}
//           <div className="contact-info">
//             <div className="info-card">
//               <div className="icon-circle">
//                 <i className="fas fa-map-marker-alt"></i>
//               </div>
//               <h3>Address</h3>
//               <p>#314, Shagun Arcade, Vijay Nagar Square, Indore, 452010</p>
//             </div>

//             <div className="info-card">
//               <div className="icon-circle">
//                 <i className="bi bi-telephone-fill"></i>
//               </div>
//               <h3>Phone</h3>
//               <p>+91 9303715744</p>
//             </div>

//             <div className="info-card">
//               <div className="icon-circle">
//                 <i className="fas fa-envelope"></i>
//               </div>
//               <h3>Email</h3>
//               <p>
//                 info@codexfuture.in<br />
//                 contact@codexfuture.in
//               </p>
//             </div>
//           </div>

//           {/* Contact Form */}
//           <div className="contact-form">
//             <h2>Send Us a Message</h2>
//             <p className="form-subtext">
//               Your email address will not be published. Required fields are marked *
//             </p>

//             <form onSubmit={handleSubmit}>
//               <div className="form-group">
//                 <textarea
//                   name="message"
//                   placeholder="Your Message *"
//                   rows="5"
//                   value={formData.message}
//                   onChange={handleChange}
//                   required
//                 ></textarea>
//               </div>
//               <div className="input-group">
//                 <input
//                   type="text"
//                   name="name"
//                   placeholder="Name *"
//                   value={formData.name}
//                   onChange={handleChange}
//                   required
//                 />
//                 <input
//                   type="email"
//                   name="email"
//                   placeholder="Email *"
//                   value={formData.email}
//                   onChange={handleChange}
//                   required
//                 />
//                 <input
//                   type="text"
//                   name="subject"
//                   placeholder="Subject"
//                   value={formData.subject}
//                   onChange={handleChange}
//                 />
//               </div>
//               <button type="submit" className="submit-btn">
//                 Submit Now →
//               </button>
//             </form>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default ContactUs;



import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./ContactUs.css";

const ContactUs = () => {
  // Step 1: Form state
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  // Step 2: Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Step 3: Handle form submit (EMAILJS INTEGRATED)
  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_wb35nww",     // 🔹 replace
        "template_8k877v8",    // 🔹 replace
        {
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
        },
        "gM4RX3KXMERId5lCE"      // 🔹 replace
      )
      .then(
        () => {
          alert("✅ Message sent successfully!");
          setFormData({ name: "", email: "", subject: "", message: "" });
        },
        (error) => {
          console.error("EmailJS Error:", error);
          alert("❌ Failed to send message.");
        }
      );
  };

  return (
    <div>
      <section className="contact-section">
        <div className="container contact-container">
          
          {/* Contact Info Cards */}
          <div className="contact-info">
            <div className="info-card">
              <div className="icon-circle">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <h3>Address</h3>
              <p>#314, Shagun Arcade, Vijay Nagar Square, Indore, 452010</p>
            </div>

            <div className="info-card">
              <div className="icon-circle">
                <i className="bi bi-telephone-fill"></i>
              </div>
              <h3>Phone</h3>
              <p>+91 9303715744</p>
            </div>

            <div className="info-card">
              <div className="icon-circle">
                <i className="fas fa-envelope"></i>
              </div>
              <h3>Email</h3>
              <p>
                info@codexfuture.in<br />
                contact@codexfuture.in
              </p>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form">
            <h2>Send Us a Message</h2>
            <p className="form-subtext">
              Your email address will not be published. Required fields are marked *
            </p>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Your Message *"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <div className="input-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Name *"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email *"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  value={formData.subject}
                  onChange={handleChange}
                />
              </div>
              <button type="submit" className="submit-btn">
                Submit Now →
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
